import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Swal from "sweetalert2";

function TestWebview() {
  
  // 통신 : 웹뷰 => 앱
  const postMessage = (msg) => {
    console.log('postMessage');
    if( window.ReactNativeWebView !== undefined ) {
      window.ReactNativeWebView.postMessage(msg);
    }
  }

  // 앱호출 : 카드결제 팝업
  const onCardPayPop = () => {
    postMessage('cardpay_open');
  }

  return <Box sx={{ p:1}}>
    <Button color="warning" fullWidth={true} variant="contained" onClick={onCardPayPop}>웹뷰 : 카드 결제창 팝업</Button>
  </Box>
}

export default TestWebview;
